import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { OfferBlock } from '../OfferBlock';
const flow = ['What to review', 'What to verify', 'What to document', 'What to prepare'];
export function FinalCta() {
  return <section className="bg-navy-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-131" data-mp="1no6p2lzgmuwh">
      <div className="mx-auto max-w-3xl" data-id="element-132" data-mp="1snsz6mjzrv12">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-133" data-mp="1smhy4uhxl1dn">
          Ready to stop searching and start following a{' '}
          <em className="italic text-teal-100" data-id="element-134" data-mp="1iq557yu7mrjy">clear GLP-1 consultation map?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-center text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-135" data-mp="14qng1id05ca2">
          Start today and organize your GLP-1 consultations with a visual system designed to help
          you identify:
        </p>

        <ol className="mt-7 flex flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-center" data-id="element-136" data-mp="2z4xzfbatve8g">
          {flow.map((step, index) => <React.Fragment key={step} data-id="element-137" data-mp="28blso7f0w24" data-mpi={index}>
              <li className="rounded-xl bg-white/[0.09] px-3.5 py-2.5 text-center text-[12px] font-extrabold uppercase tracking-wide text-white sm:text-[11px]" data-id="element-138" data-mp="27aaqjqeg9ke">
                {step}
              </li>
              {index < flow.length - 1 && <ArrowRightIcon className="mx-auto h-4 w-4 shrink-0 rotate-90 text-teal-100 sm:rotate-0" aria-hidden="true" data-id="element-139" data-mp="6zbiptgjbe4m" />}
            </React.Fragment>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-white p-5 sm:p-8" data-id="element-140" data-mp="3ai4vw55ei0y9">
          <OfferBlock label="Get the GLP-1 Decision Map™" note="Only $27 · Automatic currency conversion · Instant download · Lifetime access · 7-day guarantee" data-id="element-141" data-mp="3ogl98exrqppd" />
        </div>
      </div>
    </section>;
}